module.exports = __webpack_public_path__ + "img/tonghua2.192c70a3.png";